// extracted by mini-css-extract-plugin
export default {"chat":"ChatStyle_chat__7sRpd"};